"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.default = void 0;
var defaultLogo = {
  color: 'primary',
  width: '142px',
  height: '53px'
};
var secondaryLogo = {
  color: 'secondary',
  width: '142px',
  height: '53px'
};
var defaultUtility = {
  background: 'primary',
  foreground: 'white',
  hover: 'white',
  border: 'none',
  font: 'body',
  navWrapperTop: '-1px'
};
var defaultUtilityFooter = {
  background: 'primary',
  border: 'none',
  font: 'body',
  foreground: 'white',
  hover: 'white',
  rowBackground: 'primary'
};
var defaultPrimary = {
  accent: 'secondary',
  background: 'white',
  foreground: 'offblack',
  button: 'primary',
  hover: 'offblack',
  height: '80px',
  border: 'none',
  activeWeight: 'bold',
  breakpoint: 'medium' // TODO:

};
var defaultSecondary = {
  background: 'offwhite',
  border: 'none',
  foreground: 'offblack',
  hover: 'offblack'
};
var defaultTheme = {
  logo: defaultLogo,
  secondaryLogo: secondaryLogo,
  utility: defaultUtility,
  utilityFooter: defaultUtilityFooter,
  primary: defaultPrimary,
  secondary: defaultSecondary
};
var headers = {
  horizon: defaultTheme,
  cannesLions: {
    logo: _objectSpread(_objectSpread({}, defaultLogo), {}, {
      width: '143px',
      height: '48px'
    }),
    secondaryLogo: _objectSpread({}, secondaryLogo),
    utility: _objectSpread(_objectSpread({}, defaultUtility), {}, {
      background: 'accent3'
    }),
    utilityFooter: defaultUtilityFooter,
    primary: _objectSpread(_objectSpread({}, defaultPrimary), {}, {
      foreground: 'greydark'
    }),
    secondary: _objectSpread(_objectSpread({}, defaultSecondary), {}, {
      foreground: 'greydark'
    })
  },
  lionsLive: {
    logo: {
      color: 'white',
      width: '73px',
      height: '52px'
    },
    secondaryLogo: secondaryLogo,
    utility: _objectSpread(_objectSpread({}, defaultUtility), {}, {
      background: 'accent3',
      font: 'heading',
      navWrapperTop: '2px'
    }),
    utilityFooter: _objectSpread(_objectSpread({}, defaultUtilityFooter), {}, {
      foreground: 'offwhite',
      hover: 'offwhite'
    }),
    primary: _objectSpread(_objectSpread({}, defaultPrimary), {}, {
      border: 'greymid'
    }),
    secondary: _objectSpread(_objectSpread({}, defaultSecondary), {}, {
      background: 'white',
      border: 'greymid'
    })
  },
  money2020: {
    logo: {
      color: 'white',
      width: '119px',
      height: '64px'
    },
    secondaryLogo: secondaryLogo,
    utility: _objectSpread(_objectSpread({}, defaultUtility), {}, {
      background: 'offblack'
    }),
    utilityFooter: _objectSpread(_objectSpread({}, defaultUtilityFooter), {}, {
      background: 'white',
      foreground: 'black',
      hover: 'black'
    }),
    primary: _objectSpread(_objectSpread({}, defaultPrimary), {}, {
      background: 'primary',
      foreground: 'white',
      button: 'secondary',
      hover: 'white',
      height: '96px',
      breakpoint: 'xlarge'
    }),
    secondary: _objectSpread(_objectSpread({}, defaultSecondary), {}, {
      background: 'white',
      foreground: 'black',
      hover: 'black'
    })
  },
  ascential: {
    logo: defaultLogo,
    secondaryLogo: secondaryLogo,
    utility: _objectSpread(_objectSpread({}, defaultUtility), {}, {
      background: 'secondary',
      hover: 'white'
    }),
    utilityFooter: _objectSpread(_objectSpread({}, defaultUtilityFooter), {}, {
      background: 'secondary',
      hover: 'white'
    }),
    primary: {
      accent: 'accent1',
      background: 'white',
      foreground: 'black',
      button: 'secondary',
      hover: 'black',
      height: '96px',
      border: 'greymid',
      activeWeight: '800'
    },
    secondary: {
      background: 'offwhite',
      foreground: 'greydark',
      active: 'accent1',
      border: 'none'
    }
  },
  dcl: {
    logo: _objectSpread(_objectSpread({}, defaultLogo), {}, {
      width: '300px',
      height: '51px',
      color: 'black'
    }),
    secondaryLogo: _objectSpread(_objectSpread({}, secondaryLogo), {}, {
      color: 'white'
    }),
    utility: _objectSpread({}, defaultUtility),
    utilityFooter: _objectSpread(_objectSpread({}, defaultUtilityFooter), {}, {
      background: 'black'
    }),
    primary: _objectSpread(_objectSpread({}, defaultPrimary), {}, {
      accent: 'black',
      background: 'offwhite',
      border: 'greymid',
      activeWeight: 'bold',
      breakpoint: 'xlarge'
    }),
    secondary: _objectSpread(_objectSpread({}, defaultSecondary), {}, {
      background: 'offwhite'
    })
  },
  lionsCreativity: {
    logo: _objectSpread(_objectSpread({}, defaultLogo), {}, {
      width: '171px',
      height: '48px'
    }),
    secondaryLogo: _objectSpread(_objectSpread({}, secondaryLogo), {}, {
      color: 'white'
    }),
    utility: _objectSpread(_objectSpread({}, defaultUtility), {}, {
      background: 'accent4'
    }),
    utilityFooter: defaultUtilityFooter,
    primary: _objectSpread(_objectSpread({}, defaultPrimary), {}, {
      background: 'secondary',
      foreground: 'greydark',
      border: 'greymid',
      breakpoint: 'xlarge'
    }),
    secondary: _objectSpread(_objectSpread({}, defaultSecondary), {}, {
      foreground: 'greydark'
    })
  }
};
var _default = headers;
exports.default = _default;